import React, { FC } from 'react';
import classnames from 'classnames';
import { AllieIconButton, AllieText } from '../../../../components';
import { OrderDoneButtonsProps } from '../ProductionOrder.types';
import { AlliePlayCircleOutlineIcon } from '../../../../styling/icons';
import { StyledDescText } from '../ProductionOrder.styles';

const namespace = 'production-order';

export const OrderDoneButton: FC<OrderDoneButtonsProps> = ({
  playCircleOutline,
  onClickStartOp,
  isCurrentShift,
  ...labels
}) => {
  return (
    <AllieIconButton
      fill="outline"
      allieType="secondary"
      allieColor="neutral"
      allieSize="small"
      corner="rounded-edges"
      className={classnames(`${namespace}__action-button startOp`, {
        ['hide-component']: !isCurrentShift,
      })}
      onClick={onClickStartOp}
    >
      <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
        <AlliePlayCircleOutlineIcon style={{ width: 20, height: 20 }} />
        <StyledDescText type="body3" weight={500} color="white">
          {labels.btnStartPO}
        </StyledDescText>
      </div>
    </AllieIconButton>
  );
};
